<div class="flex items-center gap-2">
  <audio controls [src]="message.mediaUrl" class="w-72 h-10"></audio>
</div>
@if(message.text){
  <p class="p-2">{{ message.text }}</p>
}
